// extracted by mini-css-extract-plugin
export var fontBold = "j92vpRakxvJ3Utq5NEXM";
export var fontMedium = "GgHe85vsOHzhWSAFlWUo";
export var fontRegular = "gnKqz6qX1ndAV9dM96mw";
export var fontSemiBold = "gD39jDV3QBoXZH18vB8A";